import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: [
    'DV_DP_COMING_SOON_MESSAGE',
    'DV_DP_COMING_SOON_TBC_DATE',
    'DV_DP_COMING_IN_YEAR_MESSAGE',
  ] as const,
}
